import { DataSource } from '@angular/cdk/collections';
import { Component, Input, OnInit, OnChanges, OnDestroy, AfterViewInit, SimpleChanges, ViewChild, Renderer2, HostListener, ElementRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, BehaviorSubject, Observable } from 'rxjs'


export interface ColumnDefinition {
	id : number;
	label : string;
	name : string;	
	dataType : "string" | "number" | "Date";
	hidden? : boolean;
	renderData? : (row : {[key : string] : any}, column : ColumnDefinition, rowId? : number | string) => any
}

export interface RowDefinition {
	[key : string] : any;
}

export interface TableDefinition {
	columns : ColumnDefinition[];
	rows : RowDefinition[];
	pagination : { enabled : boolean; pageSizes : number[] }
}


@Component({
	selector: 'app-datatable',
	templateUrl: './datatable.component.html',
	styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
	
	private readonly tableDefinition$ : ReplaySubject<TableDefinition> = new ReplaySubject<TableDefinition>();	
	
	tableData = new MatTableDataSource<any>([]); //
	dataColumns : ColumnDefinition[];
	currentPageNumber : number = 0;
	pageSize : number = 50;
	pageCount : number = 0;

	dataRows : any[] = [];
	displayRows : any[] = [];

	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatTable, {read: ElementRef} ) private matTableRef: ElementRef;
	
	constructor(private renderer: Renderer2) {

	}

	@Input()
	set tableDefinition(value : any)
	{
		this.tableDefinition$.next(value);
	}

	ngOnInit(): void {
		this.tableDefinition$.subscribe({
			next : (data : TableDefinition) => {
				this.dataColumns = data.columns;				
				this.dataRows = data?.rows?.map((row : any, idx : number) => ({...row, id : idx}));					
				this.pageCount = Math.ceil(this.dataRows?.length / this.pageSize);
				this.currentPageNumber = this.pageCount <= 0 ? 0 : 1;
				this.displayRows = this.getDisplayRows();
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		})
	}


	ngOnDestroy(): void {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngAfterViewInit(): void {
		this.tableData.paginator = this.paginator;
	}	


	getColumnLabel = (colName : string) => {
		return this.dataColumns.find((item : ColumnDefinition) => item.name === colName)?.label;
	}
	
	get columnsToDisplay() {
		return this.dataColumns.filter((column : ColumnDefinition) => !column.hidden);
		// 	return this.dataColumns.filter((column : ColumnDefinition) => !column.hidden).map((col : ColumnDefinition) => col.name);
	}

	private resetResultsTable = () => {	
		this.tableDefinition$.next({rows : [], columns : [], pagination : { enabled : false, pageSizes : [10, 25]}});
		this.dataColumns = [];		
	}

	public columnDataRenderer = (row : {[key : string] : any}, columnName : string, rowId : number | string) => {
		return row[columnName];
	}

	public getData = (row : any, colName : string) => {
		let data = row?.[colName]?.toString()
		const column = this.dataColumns.find((col : ColumnDefinition) => col.name === colName);
		if(column && "function" === typeof(column.renderData))		
		{
			data = column.renderData(row, column);
		}

		return data;
	}

	public onPageLinkClicked = (event : any, pageNumber : number) => {
		event.preventDefault();
		if(pageNumber <= 0 || pageNumber > this.pageCount || pageNumber === this.currentPageNumber)
		{
			return;
		}
		this.currentPageNumber = pageNumber;
		this.displayRows = this.getDisplayRows();		
	}

	private getDisplayRows = () => {
		const startIdx = (this.currentPageNumber - 1) * this.pageSize;
		const data = !this.dataRows?.length ? [] :
			this.dataRows?.slice(startIdx, startIdx + this.pageSize);		
		return data;
	}

}
